<template lang="pug">
	.geo-targets--map-selector.flex-row.space-large.audio-tracker--geo-targets-list.full-height
		CartoMapComponent.flex-1(
			v-if="mapVisible",
			ref="geoTarget",
			:class="{ 'disabled-area': disabled }"
			:style="{ height: height || `${innerHeight + 80}px`}",
			:searchPlaceEnabled="true",
			:height="height",
			:showFilters="false",
			:actionsVisible="true",
			:circleDrawings="selectedGeoTargetPlace ? (selectedGeoTargetPlace.radius ? [selectedGeoTargetPlace] : []) : geoTargetDrawings",
			:geoJsonDrawings="selectedGeoTargetPlace ? (selectedGeoTargetPlace.geoJson && !selectedGeoTargetPlace.radius ? [selectedGeoTargetPlace.geoJson] : []) : geoJsonDrawings",
			:addresses="selectedGeoTargetPlace ? [] : addresses",
			@place-changed="onPlaceChanged",
		)
			.flex-row.align-center.space.template(
				v-if="selectedGeoTargetPlace",
				slot="search-actions"
			)
				.flex-col.space
					.flex-row.space-large
						DxNumberBox.region-radius(
							ref="radiusInput",
							:value="geoTargetRadius",
							:format="radiusFormat",
							:width="140",
							:placeholder="$tCaption('Radius: whole area')",
							:show-clear-button="true"
							valueChangeEvent="keyup",
							@value-changed="onGeoTargetRadiusChanged",
						)
						DxButton(
							v-if="isGeoEditing"
							:text="$tCaption('Update', '@actions')",
							type="success",
							icon="fas fa-check",
							:disabled="!!isLoading || !selectedGeoTargetPlace",
							@click="updateGeoTarget",
						)
						DxButton(
							v-else-if="!disableCreate"
							:text="$tCaption('Add', '@actions')",
							type="success",
							icon="fas fa-check",
							:disabled="!!isLoading || !selectedGeoTargetPlace",
							@click="initNewGeoTarget",
						)
						DxButton(
							v-if="!disableCreate",
							:text="$tCaption('Cancel', '@actions')",
							type="normal",
							icon="fas fa-times",
							:disabled="!!isLoading",
							@click="clearTargetPlace",
						)
						slot(name="actions")
					.flex-row.space
						DxNumberBox.lat-input(
							v-model="selectedGeoTargetPlace.lat",
							ref="latValue",
							:show-clear-button="true"
							:placeholder="$tCaption('Lat')",
							:width="190"
							:disabled="!geoTargetRadius"
							value-change-event="keyup"
							@value-changed="(v) => updateLatLng(v.value, 'lat')"
						)
						DxNumberBox.lng-input(
							v-model="selectedGeoTargetPlace.lng",
							ref="lngValue",
							:show-clear-button="true"
							:placeholder="$tCaption('Lng')",
							:width="190"
							:disabled="!geoTargetRadius"
							value-change-event="keyup"
							@value-changed="(v) => updateLatLng(v.value, 'lng')"
						)
						DxSelectBox(
							v-if="addressItems.length",
							:items="addressItems"
						)
			Loader(v-if="isLoading", slot="search-actions" text="")
		.flex-col.space.targets-list.tb-padding
			slot
		Popup(
			:popupVisible="possibleTargets.visible"
			:width="400",
			:height="540",
			:title="$tCaption('Existing locations')",
			:closeOnOutsideClick="false",
			@hiding="possibleTargets.visible = false"
		)
			.flex-col.space
				span {{$tCaption('We have found potentially same locations. Please, use one of existing or create new one.')}}
				ListView.full-width(
					ref="targetsListView",
					initialView="table",
					:height="310",
					:showViewHeader="false",
					:searchVisible="false",
					:showColumnHeaders="false",
					:bottomPagerVisible="false",
					:topPagerVisible="false",
					:hideViewsSelection="true",
					:getTotal="(r) => 999",
					:getItems="(r) => r",
					:getData="() => possibleTargets.items",
					:columns="[{ dataField: 'Name', cellTemplate: 'displayTemplate' }]",
					valueExpr="Oid",
					selectionMode="single",
					@selection="v => possibleTargets.possibleSelectedTarget = v[0]"
				)
					template(v-slot:displayTemplate="{ data }")
						.flex-col
							.flex-row.justify.space.align-center
								.flex-row.space.align-center
									.target-name.overflow(:title="data.Name") {{data.Name}}
									slot(name="target-header", :target="data")
							.target-info.flex-row.space-large.grey.font-small(v-if="data.Radius")
								.flex-row.space
									span {{$tCaption('Radius')}}
									span {{cartoApi.getRadiusDividedValue(data.Radius)}} {{kmOrMiles}}
								.flex-row.space
									span {{$tCaption('Lat')}}
									span {{data.Lat}}
								.flex-row.space
									span {{$tCaption('Lng')}}
									span {{data.Lng}}
			template(slot="actions-left")
				DxButton(
					:text="$tCaption('Create new')",
					:type="possibleTargets.possibleSelectedTarget ? 'normal' : 'success'",
					:disabled="!!isLoading",
					@click="processGeoTarget(possibleTargets.mapTarget)",
				)
			template(slot="actions-right")
				DxButton(
					:text="$tCaption('Select')",
					type="success",
					:disabled="!!isLoading || !possibleTargets.possibleSelectedTarget",
					@click="processGeoTarget(possibleTargets.possibleSelectedTarget, true)",
				)
				DxButton(
					:text="$tCaption('Cancel', '@actions')",
					@click="possibleTargets.visible = false"
				)
</template>

<script>
	import $ from 'jquery';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import DxNumberBox from 'devextreme-vue/number-box';
	import ListView from 'app-core/ListView.vue';
	import CartoMapComponent from 'view/carto/CartoMapComponent.vue';
	import api from 'view/carto/api.js';
	import resizeObserver from 'resize-observer';
	import wkt from 'wicket';
	import Popup from 'app-core/Popup.vue';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'geoTargets.List',
		name: 'geo-targets',
		props: [
			'processSelection',
			'placeResolver',
			'saveResolver',
			'disableRemove',
			'geoTargetDrawings',
			'height',
			'disabled',
			'disableCreate',
			'geoJsonDrawings',
			'addresses'
		],
		components: {
			DxTextBox,
			DxButton,
			DxNumberBox,
			DxSelectBox,
			Loader,
			ListView,
			CartoMapComponent,
			Popup,
		},
		data() {
			return {
				selectedGeoTargetPlace: null,
				isLoading: false,
				isGeoEditing: false,
				geoTargetRadius: null,
				innerHeight: 300,
				mapVisible: false,
				possibleTargets: {
					items: [],
					visible: false,
					mapTarget: null,
					possibleSelectedTarget: null
				},
				addressItems: [],
			}
		},
		computed: {
			radiusFormat() {
				return `${this.$tCaption('Radius')}: #0.## ${api.kmOrMiles()}`;
			},
			kmOrMiles() {
				return api.kmOrMiles();
			},
			cartoApi() {
				return api;
			}
		},
		watch: {
			selectedGeoTargetPlace(v) {
				this.$emit('select-target', v);
			},
			geoJsonDrawings: {
				handler() {
					this.fitItems();
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.geoTargetsMapSelector = this;
			this.$unobserve = resizeObserver.observe(this, $('body')[0], this.resizeHandler);
			this.resizeHandler();
			this.showMap();
		},
		destroyed() {
			if (this.$unobserve)
				this.$unobserve();
			delete this.$unobserve;
		},
		methods: {
			showMap() {
				this.mapVisible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.mapVisible = true;
				})
			},
			resizeHandler() {
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.innerHeight = $(window).height() - $(this.$el).offset().top - 100;
					this.$emit('resize', this.innerHeight);
				});
			},
			async onPlaceChanged(v, name) {
				this.isLoading++;
				let osPlace = await this.$Data.getLocationGeoJson({ q: v?.place?.formatted_address || name }).finally(() => this.isLoading--);
				let geoJsonItem = osPlace[0]?.geojson;
				let geoJson = `${geoJsonItem?.type}`.toLowerCase().indexOf('polygon') > -1 ? geoJsonItem : null;

				this.selectedGeoTargetPlace = null;
				let radius = geoJson ? null : 3;
				this.geoTargetRadius = radius;

				setImmediate(() => {
					if (this._isDestroyed) return;
					let target = {
						...v,
						radius: api.getMetricMultipliedValue(radius),
						combinedName: name || v?.place?.name,
						geoJson
					};
					if (__DEBUG__)
						console.debug('On place changed', { osPlace, v, target, radius });

					this.selectedGeoTargetPlace = target;

					if (this.placeResolver)
						target = this.placeResolver(target) || target;

					if (this.$refs.geoTarget)
						this.$refs.geoTarget.fitDrawnItems();

					this.$emit('place-changed', target);
				});
			},
			onGeoTargetRadiusChanged(v) {
				if (__DEBUG__) console.debug('onGeoTargetRadiusChanged', v);
				if (!v?.value && this.selectedGeoTargetPlace?.geoJson) {
					if (this.geoTargetRadius) {
						if (v?.value === 0 || v?.value === null)
							this.geoTargetRadius = null;
						if (this.selectedGeoTargetPlace)
							this.selectedGeoTargetPlace.radius = null;
						this.fitItems();
					}
					return;
				}
				let radius = Math.max(v.value, 0.01);
				if (this.geoTargetRadius === radius) return;
				if (this.selectedGeoTargetPlace) {
					this.selectedGeoTargetPlace.radius = api.getMetricMultipliedValue(radius);
				}
				this.geoTargetRadius = radius;
				this.fitItems();
			},
			fitItems() {
				this.$nextTick(() => {
					if (this.$refs.geoTarget)
						this.$refs.geoTarget.fitDrawnItems();
				});
			},
			async initNewGeoTarget() {
				let selectedTarget = {
					Name: this.selectedGeoTargetPlace.combinedName,
					...this.$Data.formatObjectToUpperCase(this.selectedGeoTargetPlace),
					Radius: this.selectedGeoTargetPlace.radius,
					IsUserDefined: this.selectedGeoTargetPlace?.isUserDefined || !!this.selectedGeoTargetPlace.radius
				};
				if (!this.selectedGeoTargetPlace?.radius && this.selectedGeoTargetPlace?.geoJson) {
					let wktObject = new wkt.Wkt();
					wktObject.fromJson(this.selectedGeoTargetPlace?.geoJson);
					selectedTarget.GeoPolygonWkt = wktObject.toString();
				}
				this.possibleTargets.mapTarget = selectedTarget;
				this.possibleTargets.possibleSelectedTarget = null;
				if (selectedTarget?.IsUserDefined) {
					this.isLoading = true;
					try {
						let possibleOwnTargets = (await this.$Data.postExternalApi('Target/GetMyPossibleTargets', selectedTarget, 100))?.Results || [];
						if (possibleOwnTargets.length) {
							this.possibleTargets.items = possibleOwnTargets;
							this.possibleTargets.visible = true;
						} else {
							this.processGeoTarget(selectedTarget);
						}
					} finally {
						this.isLoading = false;
					}
				} else {
					this.processGeoTarget(selectedTarget);
				}
			},
			processGeoTarget(target, isExisting) {
				if (__DEBUG__)
					console.debug('Process geo target', { target, isExisting });
				if (!target) return;
				this.possibleTargets.visible = false;
				if (isExisting) {
					this.$emit('create', target);
					this.clearTargetPlace();
				} else {
					this.isLoading++;
					this.$Data
						.postExternalApi('Target/CreateUpdateGeoTarget', target)
						.then(r => {
							if (__DEBUG__)
								console.debug('CreateUpdateGeoTarget result', r);
							if (r.Success) {
								this.$emit('create', r.Data);
								this.clearTargetPlace();
							}
							return r;
						})
						.finally(() => this.isLoading--);
				}
			},
			clearTargetPlace() {
				this.selectedGeoTargetPlace = null
				this.geoTargetRadius = null;
				this.isGeoEditing = false;
				this.$refs.geoTarget?.setInput('');
				this.fitItems();

				this.$emit('clearTargetPlace');
			},

			async setEditingGeoTarget(selectedTarget) {
				this.isGeoEditing = true;
				this.selectedGeoTargetPlace = null;

				const osPlace = await this.$Data.getLocationGeoJson({ q: selectedTarget.name });
				const geoJsonItem = osPlace[0]?.geojson;
				const geoJson = `${geoJsonItem?.type}`.toLowerCase().indexOf('polygon') > -1 ? geoJsonItem : null;

				setImmediate(() => {
					let target = {
						...selectedTarget,
						radius: selectedTarget.radius,
						combinedName: selectedTarget.name,
						geoJson
					};

					if (__DEBUG__)
						console.debug('Set editing GeoTarget', {
							osPlace,
							selectedTarget,
							target,
							radius: target.radius
						});

					this.selectedGeoTargetPlace = {
						...target,
						lat: target.lat,
						lng: target.lng,
					};
					this.geoTargetRadius = api.getRadiusDividedValue(target.radius);

					if (this.placeResolver)
						target = this.placeResolver(target) || target;

					this.$refs.geoTarget.setInput(target.name);
					this.$refs.geoTarget.setMapPosition({ lat: target.lat, lng: target.lng });
					this.fitItems();
					this.$emit('set-editing-geo-target', target);
				});
			},
			updateGeoTarget() {
				this.isLoading++;
				if ('geoPolygonWkt' in this.selectedGeoTargetPlace) {
					delete this.selectedGeoTargetPlace.geoPolygonWkt
				}
				this.$Data
					.postExternalApi(
						'Target/CreateUpdateGeoTarget',
						{ ...this.$Data.formatObjectToUpperCase(this.selectedGeoTargetPlace) }
					)
					.then(r => {
						if (__DEBUG__)
							console.debug('CreateUpdateGeoTarget result', r);
						if (r.Success) {
							this.$emit('update', r.Data);
							this.clearTargetPlace();
						}
						return r;
					})
					.finally(() => this.isLoading--);
			},
			updateLatLng() {
				const LatLng = {
					lat: this.selectedGeoTargetPlace.lat,
					lng: this.selectedGeoTargetPlace.lng
				};
				if (this.validateLatLng(LatLng)) {
					this.getGeocode(LatLng);
				}
			},
			getGeocode({ lat = 37.8, lng = -96 }) {
				let latlng = new google.maps.LatLng(lat, lng, null, false);
				let geocoder = new google.maps.Geocoder();

				geocoder.geocode(
					{ 'latLng': latlng },
					(results, status) => {
						if (status === google.maps.GeocoderStatus.OK) {
							this.selectedGeoTargetPlace.name = results[0].formatted_address;
							this.$refs.geoTarget.setInput(results[0].formatted_address);
						}
					});
			},
			validateLatLng({ lat, lng }) {
				let pattern = new RegExp('^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}');
				return pattern.test(lat) && pattern.test(lng);
			},
		}
	};
</script>

<style lang='scss'>
	.geo-targets--map-selector {
		padding: 4px;

		.disabled-area {
			opacity: 0.3;
			pointer-events: none;
		}
	}
</style>
